// Cargando, error y vacío. Se usan igual en todas las pantallas para que la
// aplicación se comporte siempre de la misma forma.

import type { ReactNode } from 'react';
import { Icono, type NombreIcono } from './Icono';
import { Boton } from './Boton';
import { Girador } from './Girador';

export function Cargando({ texto = 'Cargando' }: { texto?: string }) {
  return (
    <div className="cargando" role="status">
      <Girador tamano={22} />
      <span>{texto}…</span>
    </div>
  );
}

interface PropsEstadoVacio {
  icono?: NombreIcono;
  titulo: string;
  cuerpo?: ReactNode;
  accion?: ReactNode;
}

export function EstadoVacio({ icono = 'inbox', titulo, cuerpo, accion }: PropsEstadoVacio) {
  return (
    <div className="vacio">
      <div className="vacio__icono">
        <Icono nombre={icono} tamano={32} />
      </div>
      <h2 className="vacio__titulo">{titulo}</h2>
      {cuerpo && <p className="vacio__cuerpo">{cuerpo}</p>}
      {accion}
    </div>
  );
}

interface PropsFallo {
  mensaje: string;
  alReintentar?: () => void;
}

export function FalloDeCarga({ mensaje, alReintentar }: PropsFallo) {
  return (
    <div role="alert">
      <EstadoVacio
        icono="alert-triangle"
        titulo="No pudimos traer los datos"
        cuerpo={mensaje}
        accion={alReintentar && (
          <Boton variante="secundario" onClick={alReintentar}>Reintentar</Boton>
        )}
      />
    </div>
  );
}
